import { Injectable } from '@angular/core';
import { ICreditMultiContentResult, IFixChargeCMContent } from '../interfaces/IContent.interface';
import { CMCreditDataResult } from '../interfaces/credit-data-response.interface';
import { AppConfigsService } from 'ClientApp/app/config/app-configs.service';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { HttpService, IResponseLower } from 'ClientApp/app/shared/cardholders-core/services/http-service.service';
import { tap } from 'rxjs/operators';
import { ICardLoan, ICreditMultiEligibilityRequest } from '../interfaces/ICheckEligibility.interface';
import { IInsertAgreementRequest } from '../interfaces/IInsertAgreementRequest.interface';
import { IFairCreditRequest } from '../interfaces/fair-credit-request.interface';
import { IFairCreditResult } from '../interfaces/fair-credit-result.interface';
import { IcreditMultiSave } from '../interfaces/credit-multi-save.interface';
import { ITakeLoanRequest } from '../interfaces/take-loan.request';
import { ITakeLoanResponse } from '../interfaces/take-loan-response.interface';
export enum ErrorMultiType {
    TechnicalError,
    BDI,
    NotEligible,
    ProccessIncreaseFail,
    ProcessFail
}

@Injectable({
    providedIn: 'root'
})
export class CreditMultiService {
    creditMultiSave: IcreditMultiSave;
    eligibilityResponse: ICardLoan[];
    phone: string;
    cardIndex = -1;
    loadedFixCharge = false;
    isBenefitFixAmount: boolean;
    contents$: BehaviorSubject<ICreditMultiContentResult> = new BehaviorSubject<ICreditMultiContentResult>(null);
    baseApi = '';
    loaderStatus = new BehaviorSubject<boolean>(false);
    loaderCounter = 0;
    nextPage = 'main';
    fairCreditResult: IFairCreditResult;
    CreditDataResult: any;
    error: ErrorMultiType;
    takeLoanResponse: ITakeLoanResponse;
    isMobile: boolean;
    isFromFixCharge = false;
    constructor(private httpService: HttpService, private appConfigsService: AppConfigsService) {
        this.baseApi = `${this.appConfigsService.appConfigs.apiUrl}/registered/creditMulti`;
    }
    set loader(add: boolean) {
        if (add) {
            this.loaderCounter += 1;
            this.loaderStatus.next(true);
        } else {
            this.loaderCounter -= 1;
            if (this.loaderCounter < 0) {
                this.loaderCounter = 0;
            }
            if (this.loaderCounter === 0) {
                this.loaderStatus.next(false);
            }
        }
    }
    CreateCreditMultiLead(request: any): Observable<IResponseLower<any>> {
        this.loader = true;
        return this.httpService
            .postLower(`${this.appConfigsService.appConfigs.apiUrl}/registered/creditMulti/createLead`, request)
            .pipe(
                tap((res: IResponseLower<any>) => {
                    this.loader = false;
                })
            );
    }
    // checkEligibility(isMobile: boolean): Observable<IResponseLower<ICardLoan>> {
    //     const req: ICreditMultiEligibilityRequest = {
    //         cardIndex: isMobile ? -1 : this.cardIndex,
    //         isBenefitFixAmount: isMobile ? false : this.isBenefitFixAmount,
    //         isMobile: isMobile
    //     };
    //     this.loader = true;
    //     return this.httpService.postLower<ICardLoan>(`${this.baseApi}/checkEligibility`, req).pipe(
    //         tap((x: IResponseLower<any>) => {
    //             this.loader = false;
    //             this.eligibilityResponse = x.result;
    //             if (x.returnCode === 0 && isMobile) {
    //                 this.cardIndex = x.result.cardIndex;
    //                 this.isBenefitFixAmount = x.result.isBenefitFixAmount;
    //                 this.phone = x.result.phoneNumber;
    //             }
    //         })
    //     );
    // }
    checkEligibilityAll(isMobile: boolean): Observable<IResponseLower<ICardLoan>> {
        const req: ICreditMultiEligibilityRequest = {
            isBenefitFixAmount: isMobile ? false : this.isBenefitFixAmount,
            isMobile: isMobile,
            isFromFixCharge: this.isFromFixCharge
        };
        this.loader = true;
        return this.httpService.postLower<ICardLoan>(`${this.baseApi}/checkEligibility`, req).pipe(
            tap((x: IResponseLower<any>) => {
                this.loader = false;
                this.eligibilityResponse = x.result;
                if (x.returnCode === 0 && isMobile) {
                    this.cardIndex = x.result[0].cardIndex;
                    this.isBenefitFixAmount = x.result[0].isBenefitFixAmount;
                    this.isFromFixCharge = true;
                    this.phone = x.result[0].phoneNumber;
                }
            })
        );
    }

    CreditData(): Observable<IResponseLower<CMCreditDataResult>> {
        this.loader = true;
        return this.httpService.postLower(`${this.baseApi}/creditData`, { loanAmountForBdi: this.creditMultiSave.creditAmount, cardIndex: this.cardIndex }).pipe(
            tap((res: IResponseLower<CMCreditDataResult>) => {
                if (res.returnCode === 0) {
                    this.CreditDataResult = res.result;
                    this.loader = false;
                }
            })
        );
    }
    InsertNewAgreement(req: IInsertAgreementRequest): Observable<IResponseLower<CMCreditDataResult>> {
        this.loader = true;
        return this.httpService.postLower<CMCreditDataResult>(`${this.baseApi}/InsertNewAgreement`, req).pipe(
            tap(x => {
                this.loader = false;
            })
        );
    }
    calcTotalDeferralBridgingInterest(request: IFairCreditRequest): Observable<IResponseLower<number>> {
        return this.httpService.postLower(`${this.baseApi}/calcTotalDeferralBridgingInterest`, request);
    }
    fairCreditData(request: IFairCreditRequest): Observable<IResponseLower<IFairCreditResult>> {
        this.loader = true;

        return this.httpService.postLower(`${this.baseApi}/getFairCreditData`, request).pipe(
            tap((res: IResponseLower<IFairCreditResult>) => {
                this.loader = false;
                if (res.returnCode === 0) {
                    this.fairCreditResult = res.result;
                }
            })
        );
    }
    takeLoan(request: ITakeLoanRequest): Observable<IResponseLower<ITakeLoanResponse>> {
        this.loader = true;

        return this.httpService.postLower(`${this.baseApi}/takeLoan`, request).pipe(
            tap((res: IResponseLower<ITakeLoanResponse>) => {
                this.loader = false;
                if (res.returnCode === 0) {
                    this.takeLoanResponse = res.result;
                }
            })
        );
    }

    getSelectedCardInfo(): ICardLoan {
        return this.eligibilityResponse.find(x => x.dealInfo.cardIndex === this.cardIndex);
    }

    getContent(req: 'all' | 'fixCharge' = 'all'): Observable<IResponseLower<any>> {
        this.loader = true;
        return this.httpService.getLower<any>(`${this.baseApi}/getContents?For=${req}`).pipe(
            tap(x => {
                this.loader = false;

                if (x.returnCode === 0 && x.result) {
                    switch (req) {
                        case 'all':
                            this.contents$.next(x.result);
                            break;
                        case 'fixCharge':
                            this.contents$.next({ ...this.contents$.getValue(), fixChargeCmContent: x.result });
                            break;

                        default:
                            break;
                    }
                }
            })
        );
    }
}
